export default __webpack_public_path__ + "bcf2ba9ef2bd549116a9ef37df731ba6.svg";